<template>
  <router-link to="/muttertag" class="mothersday has-background-primary is-block is-clipped is-relative">
    <div class="columns  is-multiline is-vcentered" v-if="$whitelabel.short.toLowerCase() === 'adac'">
      <div
        class="column is-8-tablet is-offset-2-tablet is-5-widescreen is-6-desktop is-offset-0-desktop mothersday__content mothersday__content--adac mt-3">
        <div class="has-text-centered-touch mothersday__text--adac">
          <div
            class="title is-inline-block is-size-3-mobile is-size-2-tablet is-size-1-widescreen has-text-weight-bold has-text-black">
            <p
              class="has-background-secondary is-size-5 is-size-3-tablet  is-inline-block has-text-weight-bold has-text-white pr-1 pl-1 mb-3">
              ADAC Hotelgutschein
            </p>

            <p><span class="is-inline-block-tablet is-block-mobile has-text-black">Urlaubsfreude</span> <span
                class="is-inline-block">zum Muttertag</span></p>
          </div>
          <p class=" has-text-black is-size-6 is-size-5-tablet has-text-weight-bold">Ausgewählte (R)auszeiten für unsere
            Mamas!</p>

          <b-button tag="router-link" to="/muttertag" type="is-light" size="is-medium" class="mt-5">
            Zum Muttertags-Special
          </b-button>
        </div>
      </div>
      <div class="column is-12-tablet is-7-widescreen is-6-desktop mothersday__img--adac">
        <p class=" has-text-centered has-text-right-desktop">
          <img fetchpriority="high"
            :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=800&quality=50&type=auto&interlace=true&file=whitelabel/adac/campaigns/muttertag.png`"
            alt="Muttertag" width="781" height="326" />
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'mothersday',

  props: {},
  methods: {},
}
</script>

<style scoped lang="scss">
.mothersday {
  .title {
    margin-bottom: 0.75rem;
  }
}

.mothersday-bunny {
  position: absolute;
  bottom: -3.6vw;
  right: 0.6rem;
  width: 20vw;

  @media screen and (min-width: 769px) {
    bottom: -2.5rem;
    width: 160px;
  }
}

.mothersday__content {
  @media screen and (min-width: 769px) {
    margin-top: 3rem;
  }
}

.mothersday__text--adac {}

@media screen and (min-width: 1024px) {
  .mothersday__text--adac {
    margin-top: 1rem;
    margin-bottom: 2rem;
    margin-left: 3rem;
    margin-right: 0;
  }

  .mothersday__img--adac {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

@media screen and (min-width: 1216px) {
  .mothersday__img--adac {
    margin-right: 3rem;
    margin-left: -4rem;
  }
}
</style>
